export const TICKET_SELECTION_QA = 'ticketSelection';
export const TICKET_QA = 'formStyleTicket';
export const NAME_QA = 'formStyleTicketName';
export const DESCRIPTION_QA = 'formStyleTicketDescription';
export const PRICE_QA = 'formStyleTicketPrice';
export const REMAINING_QA = 'formStyleTicketRemaining';
export const DATE_TIME_QA = 'formStyleTicketDateTime';
export const TICKET_HEADER_QA = 'formStyleTicketHeader';
export const QUANTITY_QA = 'formStyleTicketQuantity';
